/**
 * Traverses parents until one is found that has class 'dropdown', then toggles the active class on that element.
 *
 * @param  {Event} event
 * @return {Void}
 */
export const toggleDropdown =(event) => {
    let element = event.currentTarget;

    // eslint-disable-next-line no-cond-assign
    while (element = element.parentElement) {
        if (element.classList.contains('dropdown')) {
            element.classList.toggle('dropdown--active');
            break;
        }
    }
}